
const country = process.env.REACT_APP_COUNTRY || 'ch';
const links_urlPrefix = process.env.REACT_APP_RELATIVEURLS === "yes" ? "/" : `https://appentura.${country}/`
// const links_urlPrefix = routerBasename === "shop" ? "/" : "https://appentura.ch/";
const links = {
  about:{
    href: `${links_urlPrefix}about`,
    label:"Über uns"
  },
  howItWorks: {
    href: `${links_urlPrefix}wie-funktioniert-appentura`,
    label: "Wie funktioniert es?"
  },
  faq: {
    href: `${links_urlPrefix}faq`,
    label:"FAQ"
  },
  blog: {
    href: `${links_urlPrefix}blog`,
    label:"Blog"
  },
  conditions: {
    href: `${links_urlPrefix}agb`,
    label: "AGB"
  },
  imprint: {
    href: `${links_urlPrefix}impressum`,
    label: "Impressum"
  },
  dataProtection: {
    href: `${links_urlPrefix}datenschutz`,
    label: "Datenschutz"
  },
  employeeGifts: {
    href: "https://mitarbeitergeschenke.appentura.ch",
    label: "Mitarbeitergeschenke"
  },
  employeeGiftsQuote: {
    href: `${links_urlPrefix}offerte-anfragen`,
    label: "Mitarbeitergeschenke - Offerte anfragen"
  },
  events: {
    href: `${links_urlPrefix}anlaesse`,
    label: "Anlässe"
  },
  b2b: {
    href: `${links_urlPrefix}firmenkunden`,
    label: "Firmenkunden"
  },
  contact: {
    href: `${links_urlPrefix}contact`,
    label: "Kontakt"
  },
  partners: {
    href: `${links_urlPrefix}erlebnispartner`,
    label: "Erlebnispartner"
  },
  career: {
    href: `${links_urlPrefix}karriere`,
    label: "Karriere"
  },
  reports: {
    href: `${links_urlPrefix}erlebnisberichte`,
    label: "Erlebnisberichte"
  },
  ideas: {
    href: `${links_urlPrefix}geschenkideen`,
    label: "Geschenkideen"
  }
}

export default links